import React, { useState, useEffect } from "react";

import Table from "../../../common/Table";

const DataList = ({ data }) => {
  const { yesterdayBalance, totalRevenue, totalExpense } = data;

  const columns = [
    { path: "label", label: "خلاصه" },
    { path: "balance", label: "بیلانس" },
  ];

  useEffect(() => {
    let currentBalance = (
        parseFloat(totalRevenue) -
        parseFloat(totalExpense)
    ).toFixed(2);

    let newData = [
      {label: "درآمد", balance: totalRevenue},
      {label: "مصرف", balance: totalExpense},
      {label: "بیلانس فعلی", balance: currentBalance},
    ];

    if(yesterdayBalance) {
      currentBalance = (
          parseFloat(yesterdayBalance) +
          parseFloat(totalRevenue) -
          parseFloat(totalExpense)
      ).toFixed(2);

      newData = [
        {label: "بیلانس روز قبل", balance: yesterdayBalance},
        {label: "درآمد", balance: totalRevenue},
        {label: "مصرف", balance: totalExpense},
        {label: "بیلانس فعلی", balance: currentBalance},
      ];
    }
    setData(newData);
  }, [totalRevenue, yesterdayBalance, totalExpense]);

  const [_data, setData] = useState([]);

  return <Table data={_data} columns={columns} />;
};

export default DataList;
